/**
 * Utility functions for handling canonical URLs consistently
 */

const BASE_URL = 'https://homeworkguy.org';

/**
 * Get the canonical URL for a given path
 * Handles special cases like blog pages with query parameters
 */
export const getCanonicalUrl = (pathname: string, search: string = ''): string => {
  // Remove trailing slashes except for root
  let cleanPath = pathname.replace(/\/$/, '');
  if (cleanPath === '') cleanPath = '/';
  
  // Special handling for blog pages with query parameters
  if (cleanPath === '/blog' && search) {
    // Always return the main blog URL as canonical
    return `${BASE_URL}/blog`;
  }
  
  // For all other pages, return the clean URL without query params
  return `${BASE_URL}${cleanPath}`;
};

/**
 * Check if a URL needs a redirect (has trailing slash or query params that should be removed)
 */
export const needsRedirect = (pathname: string, search: string = ''): boolean => {
  // Check for trailing slash (except root)
  if (pathname !== '/' && pathname.endsWith('/')) {
    return true;
  }
  
  // Check for blog query parameters
  if (pathname === '/blog' && search) {
    return true;
  }
  
  return false;
};

/**
 * Get the redirect URL for a path that needs redirecting
 */
export const getRedirectUrl = (pathname: string, search: string = ''): string => {
  // Remove trailing slash
  let cleanPath = pathname.replace(/\/$/, '');
  if (cleanPath === '') cleanPath = '/';
  
  // Remove query params for blog
  if (cleanPath === '/blog' && search) {
    return '/blog';
  }
  
  return cleanPath;
};

/**
 * List of paths that should not be indexed when they have query parameters
 */
export const noIndexWithParams = [
  '/blog', // Adding back to ensure blog pages with parameters are not indexed
  '/search',
  '/order'
];

/**
 * Check if a page should have noindex meta tag
 */
export const shouldNoIndex = (pathname: string, search: string = ''): boolean => {
  const cleanPath = pathname.replace(/\/$/, '');
  
  // If path is in noIndexWithParams list and has query params, add noindex
  if (search && noIndexWithParams.includes(cleanPath)) {
    return true;
  }
  
  return false;
}; 